import { Fetcher } from "swr";

const fetcher: Fetcher<any> = (args: RequestInfo) => fetch(args).then((res) => res.json());
export default fetcher;
